import React from "react";

import {
  AlertOutlined,
  AppstoreOutlined,
  BugOutlined,
  DesktopOutlined,
  DollarCircleOutlined,
  FileDoneOutlined,
  FilterOutlined,
  FlagOutlined,
  IssuesCloseOutlined,
  MailOutlined,
  MessageOutlined,
  QuestionCircleOutlined,
  RocketOutlined,
  RotateLeftOutlined,
  SelectOutlined,
  VerticalAlignTopOutlined,
  WarningOutlined,
} from "@ant-design/icons";

import {
  VIEW_AIRLINES_PAGE_PERM,
  VIEW_AIRLINES_PRODUCTIVITY_PAGE_PERM,
  VIEW_ALERTS_PAGE_PERM,
  VIEW_AUCTION_PAGE_PERM,
  VIEW_BOOKINGS_PAGE_PERM,
  VIEW_CLICKS_PAGE_PERM,
  VIEW_CONTACT_US_PAGE_PERM,
  VIEW_CONVERSIONS_PAGE_PERM,
  VIEW_DASHBOARD_PAGE_PERM,
  VIEW_DEBUG_PAGE_PERM,
  VIEW_DIRECTIONS_PAGE_PERM,
  VIEW_ERRORS_PAGE_PERM,
  VIEW_FAQ_PAGE_PERM,
  VIEW_FEEDBACKS_PAGE_PERM,
  VIEW_GATE_TESTER_PAGE_PERM,
  VIEW_HOSTS_PAGE_PERM,
  VIEW_REPORTS_PAGE_PERM,
} from "../../permissions";
import { UserRoute } from "../../routes";
import { APIDocsOutlined } from "../icons";

export interface MenuItem {
  title: string;
  link: string;
  linkProps?: any;
  icon: React.ReactNode;
  permissions: string[];
  children?: MenuItem[];
  disabled?: boolean;
}

const MenuItems: MenuItem[][] = [
  [
    {
      title: "sidebar:menu-items.dashboard",
      link: UserRoute.Dashboard,
      icon: <AppstoreOutlined />,
      permissions: [VIEW_DASHBOARD_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.reports",
      link: UserRoute.Reports,
      icon: <FileDoneOutlined />,
      permissions: [VIEW_REPORTS_PAGE_PERM],
    },
  ],
  [
    {
      title: "sidebar:menu-items.conversions.title",
      link: UserRoute.Conversions,
      icon: <FlagOutlined />,
      permissions: [VIEW_CONVERSIONS_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.hosts",
      link: UserRoute.Hosts,
      icon: <DesktopOutlined />,
      permissions: [VIEW_HOSTS_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.clicks",
      link: UserRoute.Clicks,
      icon: <SelectOutlined />,
      permissions: [VIEW_CLICKS_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.airlines.title",
      link: UserRoute.Airlines,
      icon: <RocketOutlined />,
      permissions: [VIEW_AIRLINES_PAGE_PERM, VIEW_AIRLINES_PRODUCTIVITY_PAGE_PERM],
      children: [
        {
          title: "sidebar:menu-items.airlines.main",
          link: UserRoute.Airlines,
          icon: <RocketOutlined />,
          permissions: [VIEW_AIRLINES_PAGE_PERM],
        },
        {
          title: "sidebar:menu-items.airlines.productivity",
          link: UserRoute.AirlinesProductivity,
          icon: <FilterOutlined />,
          permissions: [VIEW_AIRLINES_PRODUCTIVITY_PAGE_PERM],
        },
      ],
    },
    {
      title: "sidebar:menu-items.bookings",
      link: UserRoute.Bookings,
      icon: <DollarCircleOutlined />,
      permissions: [VIEW_BOOKINGS_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.directions",
      link: UserRoute.Directions,
      icon: <RotateLeftOutlined />,
      permissions: [VIEW_DIRECTIONS_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.auction",
      link: UserRoute.Auction,
      icon: <VerticalAlignTopOutlined />,
      permissions: [VIEW_AUCTION_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.feedback",
      link: UserRoute.Feedbacks,
      icon: <MessageOutlined />,
      permissions: [VIEW_FEEDBACKS_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.errors",
      link: UserRoute.Errors,
      icon: <WarningOutlined />,
      permissions: [VIEW_ERRORS_PAGE_PERM],
    },
  ],
  [
    {
      title: "sidebar:menu-items.alerts",
      link: UserRoute.Alerts,
      icon: <AlertOutlined />,
      permissions: [VIEW_ALERTS_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.helps",
      link: UserRoute.FAQCategories,
      icon: <QuestionCircleOutlined />,
      permissions: [VIEW_FAQ_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.debug",
      link: UserRoute.Debug,
      icon: <BugOutlined />,
      permissions: [VIEW_DEBUG_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.gate-tester",
      link: UserRoute.GateTester,
      icon: <IssuesCloseOutlined />,
      permissions: [VIEW_GATE_TESTER_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.contact",
      link: UserRoute.Contact,
      icon: <MailOutlined />,
      permissions: [VIEW_CONTACT_US_PAGE_PERM],
    },
    {
      title: "sidebar:menu-items.api-documentation",
      link: "/api/docs/",
      icon: <APIDocsOutlined />,
      linkProps: { target: "_blank" },
      permissions: [],
    },
  ],
];

export { MenuItems };
